// extracted by mini-css-extract-plugin
export default {"container":"MedicalCenterRefinements_container__932Sq","aside":"MedicalCenterRefinements_aside__yqGJd","title":"MedicalCenterRefinements_title__oxQuw"};